<template>
  <v-dialog
    v-model="dialogoAniversario"
    width="600px"
    transition="dialog-top-transition"
    @click:outside="mostrarDialogo(false)"
    @keydown.esc="mostrarDialogo(false)"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    class="ma-0"
    max-height="98%"
  >
    <v-carousel
      height="100%"
      style="min-height: 175px !important"
      hide-delimiters
      cycle
      dark
      continuous
      :show-arrows="popUps.length > 1"
    >
      <template v-slot:prev="{ on, attrs }">
        <v-btn small color="white" fab v-bind="attrs" v-on="on">
          <v-icon color="black">mdi-chevron-left</v-icon>
        </v-btn>
      </template>
      <template v-slot:next="{ on, attrs }">
        <v-btn small color="white" fab v-bind="attrs" v-on="on">
          <v-icon color="black">mdi-chevron-right</v-icon>
        </v-btn>
      </template>
      <v-carousel-item
        v-for="(popUp, i) in popUps"
        :key="i"
        style="min-height: 175px !important"
      >
        <v-card height="100%" color="white" tile min-height="500px">
          <v-toolbar height="40" flat color="primary" dark>
            <v-btn icon dark @click="mostrarDialogo(false)" tile absolute>
              <v-icon>mdi-close-circle</v-icon>
            </v-btn>
            <v-toolbar-title class="titulo texto-20 mx-auto">
              {{ popUp.title }}
            </v-toolbar-title>
          </v-toolbar>
          <div
            class="ql-content ql-editor noticia-style pa-2 ma-0"
            v-sane-html="popUp.body"
          ></div>
        </v-card>
      </v-carousel-item>
    </v-carousel>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  computed: {
    ...mapState(["dialogoAniversario", "popUps"]),
  },
  methods: {
    ...mapActions(["mostrarDialogo"]),
  },
};
</script>
<style>
.noticia-style img {
  max-width: 100% !important;
  cursor: default !important;
}
.my-img-container {
  position: relative;
  padding-top: 50%;
}
.my-img-container:before {
  content: " ";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 80px;
  height: 80px;
  border: 2px solid red;
  border-color: transparent red transparent red;
  border-radius: 50%;
  animation: loader 1s linear infinite;
}
.my-img-container > img {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100% !important;
  height: 100% !important;
}
@keyframes loader {
  0% {
    transform: translate(-50%, -50%) rotate(0deg);
  }
  100% {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}
</style>
